import { render, staticRenderFns } from "./FollowPanel.vue?vue&type=template&id=2604b8f4&scoped=true&"
import script from "./FollowPanel.vue?vue&type=script&lang=js&"
export * from "./FollowPanel.vue?vue&type=script&lang=js&"
import style0 from "./FollowPanel.vue?vue&type=style&index=0&id=2604b8f4&scoped=true&lang=css&"
import style1 from "./FollowPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604b8f4",
  null
  
)

export default component.exports